import { render, staticRenderFns } from "./BranchCombobox.vue?vue&type=template&id=1664b125&scoped=true"
import script from "./BranchCombobox.vue?vue&type=script&lang=js"
export * from "./BranchCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1664b125",
  null
  
)

export default component.exports